import React, { useState } from "react";
import { motion } from "framer-motion";
import { useEffect } from "react";
import CarCard from "../components/CarCard";
import logo from "../assets/vint50.png";
import PrebookingModal from "../components/PrebookingModal";
import CaptchaModal from "../components/CaptchaModal";

const CataloguePage = () => {
    const [cars, setCars] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showCaptcha, setShowCaptcha] = useState(false);
    const [captchaToken, setCaptchaToken] = useState(null);
    const [selectedCar, setSelectedCar] = useState(null);

    useEffect(() => {
        const fetchCars = async () => {
            try {
                console.log("Fetching data from:", process.env.REACT_APP_DATA_URL);
                const response = await fetch(process.env.REACT_APP_DATA_URL);

                const contentType = response.headers.get("content-type");
                if (contentType && contentType.indexOf("application/json") === -1) {
                    const text = await response.text();
                    console.error("Received non-JSON response:", text.substring(0, 100));
                    throw new Error(`Expected JSON but received ${contentType}`);
                }

                if (!response.ok) {
                    throw new Error('Failed to fetch data');
                }
                const data = await response.json();

                // Process data: prepend image URL and reverse order
                const processedData = data.map(car => ({
                    ...car,
                    image: `${process.env.REACT_APP_IMAGE_BASE_URL}${car.image}`
                })).reverse();

                setCars(processedData);
                setLoading(false);
            } catch (err) {
                console.error("Error fetching car data:", err);
                setError(err.message);
                setLoading(false);
            }
        };

        fetchCars();
    }, []);

    const handlePrebook = (car) => {
        setSelectedCar(car);
        setShowCaptcha(true);
    };

    const handleCaptchaVerified = (token) => {
        setCaptchaToken(token);
        setShowCaptcha(false);
        setIsModalOpen(true);
    };

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.5 }
        }
    };

    if (loading) {
        return (
            <div
                className="d-flex justify-content-center align-items-center"
                style={{ minHeight: "100vh", background: "var(--bg-dark)", color: "var(--highlight-gold)" }}
            >
                <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div
                className="d-flex justify-content-center align-items-center"
                style={{ minHeight: "100vh", background: "var(--bg-dark)", color: "var(--text-main)" }}
            >
                <div className="text-center">
                    <h2 className="mb-3">Oops! Something went wrong.</h2>
                    <p className="text-danger">{error}</p>
                </div>
            </div>
        );
    }

    return (
        <div
            style={{
                minHeight: "100vh",
                background: "var(--bg-dark)",
                paddingTop: "100px",
            }}
        >
            <div className="container py-5">
                <motion.div
                    className="text-center mb-5"
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                >
                    <img
                        src={logo}
                        alt="Logo"
                        style={{
                            width: "150px",
                            height: "auto",
                            marginBottom: "20px",
                            filter: "brightness(0.9)"
                        }}
                    />
                    <h1
                        className="fw-bold mb-3"
                        style={{
                            fontSize: "clamp(2.5rem, 5vw, 4rem)",
                            color: "var(--text-main)",
                            fontFamily: "var(--font-heading)",
                        }}
                    >
                        Our Vintage Collection
                    </h1>
                    <p
                        className="fs-5"
                        style={{ color: "var(--text-muted)", letterSpacing: "1px" }}
                    >
                        Discover Automotive History
                    </p>
                    <div style={{ width: "60px", height: "3px", background: "var(--highlight-gold)", margin: "20px auto" }}></div>
                </motion.div>

                {/* CAR GRID - Reversed Order */}
                {cars.length === 0 ? (
                    <div className="text-center mt-5">
                        <h3 style={{ color: "var(--highlight-gold)" }}>New car coming soon</h3>
                        <p style={{ color: "var(--text-muted)" }}>Stay tuned for our latest additions!</p>
                    </div>
                ) : (
                    <motion.div
                        className="row g-4"
                        variants={containerVariants}
                        initial="hidden"
                        animate="visible"
                    >
                        {cars.map((car) => (
                            <motion.div key={car.id} className="col-12 col-sm-6 col-lg-4" variants={itemVariants}>
                                <CarCard car={car} onPrebook={handlePrebook} />
                            </motion.div>
                        ))}
                    </motion.div>
                )}
            </div>
            <PrebookingModal
                isOpen={isModalOpen}
                onClose={() => {
                    setIsModalOpen(false);
                    setCaptchaToken(null);
                }}
                carModel={selectedCar?.name}
                captchaToken={captchaToken}
            />
            <CaptchaModal
                show={showCaptcha}
                onHide={() => setShowCaptcha(false)}
                onVerified={handleCaptchaVerified}
            />
        </div>
    );
};

export default CataloguePage;
